// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3889bc20","446":"55e0218b","451":"60ff8f8d","546":"60769d1e","576":"545f078c","665":"38fc635c","897":"f489fc0d"}[chunkId] + ".chunk.js";
};